import React from 'react';
import Icon from '../../../components/AppIcon';

const StatisticsSection = ({ language }) => {
  const content = {
    en: {
      title: "Our Impact in Numbers",
      stats: [
        {
          icon: "Calendar",
          value: "15+",
          label: "Years in Business"
        },
        {
          icon: "MapPin",
          value: "4",
          label: "African Countries"
        },
        {
          icon: "Users",
          value: "200+",
          label: "Satisfied Customers"
        },
        {
          icon: "Package",
          value: "5,000+",
          label: "Tons Imported"
        }
      ]
    },
    zh: {
      title: "我们的影响力数字",
      stats: [
        {
          icon: "Calendar",
          value: "15+",
          label: "年业务经验"
        },
        {
          icon: "MapPin",
          value: "4",
          label: "非洲国家"
        },
        {
          icon: "Users",
          value: "200+",
          label: "满意客户"
        },
        {
          icon: "Package",
          value: "5,000+",
          label: "吨进口量"
        }
      ]
    }
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 bg-primary/5">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground text-center mb-12 md:mb-16">
          {content?.[language]?.title}
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {content?.[language]?.stats?.map((stat, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-lg p-6 md:p-8 text-center hover:shadow-lg transition-smooth"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name={stat?.icon} size={28} color="var(--color-primary)" />
              </div>
              <div className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary mb-2">
                {stat?.value}
              </div>
              <div className="text-sm md:text-base text-muted-foreground font-medium">
                {stat?.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection;